import { AsyncForm } from '@components/async-form';
import { BaseDialog, DialogFooter, DialogHeader, showGlobal } from '@components/dialog';
import { rpx } from 'client/lib/rpx-client';
import { showToast } from '@components/toaster';

export function showConfirmEmailDialog() {
  showGlobal<void>(({ resolve }) => {
    return <ConfirmEmailDialog close={resolve}></ConfirmEmailDialog>;
  });
}

export function ConfirmEmailDialog({ close }: { close(): void }) {
  async function sendEmailVerification() {
    await rpx.auth.emailVerification({
      returnURL: location.origin + location.pathname,
    });

    showToast({ title: 'Success', message: 'Verification Email Sent', type: 'ok' });
    close();
  }

  return (
    <BaseDialog
      onClose={() => {
        close();
      }}
      zIndex="z-max"
    >
      <AsyncForm class="flex flex-col gap-6" onSubmit={sendEmailVerification}>
        <section class="flex flex-col sm:gap-6 gap-10 sm:p-10">
          <DialogHeader title="Email Verification Required" />
          <div>
            To send messages and previews, please verify your email address first. This helps us
            keep your account secure.
          </div>
          <DialogFooter confirmButtonText="Verify My Email" onClose={close} />
        </section>
      </AsyncForm>
    </BaseDialog>
  );
}
